import { getRequest, postRequest } from "app/axiosClient";
import {
  VisitHistoryListSuccess,
  VisitHistoryDetails,
  getAppointmentDetails,
  showLocalLoader,
  hideLocalLoader,
  resetState,
  resetOnSearch,
  updatePgNumber,
} from "./VisitHistorySlice";
import {
  showLoader,
  hideLoader,
} from "../CommonComponents/GlobalSpinner/GlobalSpinnerSlice";
import OpenNotificationWithIcon from "common/utils/OpenNotificationWithIcon";
export const getVisitHistoryApi = (payload) => (dispatch) => {
  try {
    dispatch(showLocalLoader());
    return postRequest(`api/Appointment/PastVisits`, payload)
      .then((res) => {
        dispatch(VisitHistoryListSuccess(res.data));
        dispatch(hideLocalLoader());
        return res.data;
      })
      .catch((e) => {
        dispatch(hideLocalLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "Visits.Unablefetchvisitlist"
        );
        return false;
      });
  } catch (e) {
    dispatch(hideLocalLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Visits.Unablefetchvisitlist"
    );
    return false;
  }
};

export const getVisitHistoryDetailsApi = (payload) => (dispatch) => {
  try {
    dispatch(showLoader());
    return getRequest(
      `api/Appointment/VisitDetails?appointmentNbr=${payload.appointmentNbr}&noteID=${payload.noteId}&locale=0`
    )
      .then((res) => {
        dispatch(VisitHistoryDetails(res.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "Visits.Unablefetchdata"
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Visits.Unablefetchdata"
    );
  }
};

export const forVisitDetailsApi = (visitNoteId) => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(`api/Appointment/Details?appointmentNoteId=${visitNoteId}`)
      .then((res) => {
        var obj = {
          noteId: visitNoteId,
          appointmentNbr: res.data[0].appointmentNbr,
        };
        dispatch(getVisitHistoryDetailsApi(obj));
      })
      .catch((e) => {
        dispatch(hideLoader());
      });
  } catch (e) {
    dispatch(hideLoader());
  }
};

export const getAppointmentDetailsApi = (appointmentNoteId) => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(`api/Appointment/Details?appointmentNoteId=${appointmentNoteId}`)
      .then((res) => {
        dispatch(getAppointmentDetails(res.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        dispatch(hideLoader());
      });
  } catch (e) {
    dispatch(hideLoader());
  }
};

export const clearVisitsStateApi = () => (dispatch) => {
  dispatch(resetState());
};

export const clearVisitsOnSearchApi = () => (dispatch) => {
  dispatch(resetOnSearch());
};

export const setPageNo = (pgNumber) => (dispatch) =>
  Promise.all([dispatch(updatePgNumber(pgNumber))]);
